import { HttpService, JsonObject, JsonProperty, API_URL, AbstractModel } from 'projects/core/src/public-api';

@JsonObject('model.OrderEmail')
export class OrderEmail extends AbstractModel {
	@JsonProperty(String, 'email')
	email: string;

	@JsonProperty(String, 'text')
	text: string;
}
